module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/en_hokkaido-c6df10be35a2d01d6da9ed4cc45ad904.jpg";